/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DocumentId } from "../../commons/types/DocumentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { DocumentConfig } from "./DocumentConfig";
export const Document = core.serialization
    .object({
    id: DocumentId,
    spaceId: SpaceId.optional(),
    environmentId: EnvironmentId.optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    createdFrom: DocumentId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
})
    .extend(DocumentConfig);
